import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { FormationData } from '../../shared/dto/EntityRepository';
import { PEHeader, PEIndicator, SelectBoxContainer, SelectBoxWrapper } from './Work';
import FormationGridView from './formation/FormationGridView';
import SelectBox from '../../shared/component/SelectBox';
import { DisplaySize, normalizePEInfoType, PEInfoType, SelectType } from '../../shared/enum/EnumRepository';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import {
  getFormationTypeLabel,
  normalizeFormationDisplaySize,
  normalizeFormationType,
} from '../../shared/util/formationUtils';
import {
  FORMATION_DISPLAY_SIZE_OPTIONS,
  FORMATION_TYPE_OPTIONS,
} from './formation/formationGrid';

export interface FormationProps {
  peId: string;
  data: FormationData;
  displaySize: DisplaySize;
  infoType?: PEInfoType;
}

const Formation: React.FC<FormationProps> = ({ peId, data, displaySize, infoType }) => {
  const { isEditMode } = useEditMode();
  const updateFormationType = useProjectElementListStore((s) => s.updateFormationType);
  const handleDisplaySizeChange = useProjectElementListStore((s) => s.updateDisplaySize);
  const handleInfoTypeChange = useProjectElementListStore((s) => s.updateInfoType);
  const effectiveDisplaySize = normalizeFormationDisplaySize(displaySize);
  const effectiveFormationType = normalizeFormationType(data.formationType);
  const effectiveInfoType = normalizePEInfoType(infoType);

  return (
    <FormationWrapper>
      {isEditMode && (
        <PEHeader>
          <SelectBoxContainer>
            <SelectBoxWrapper>
              <SelectBox
                value={effectiveDisplaySize}
                options={FORMATION_DISPLAY_SIZE_OPTIONS}
                handleChange={(value) => handleDisplaySizeChange(peId, value)}
                direction={false}
              />
            </SelectBoxWrapper>
            <SelectBoxWrapper>
              <SelectBox
                value={effectiveFormationType}
                options={FORMATION_TYPE_OPTIONS}
                handleChange={(value) => updateFormationType(peId, value)}
                direction={false}
                getDisplayText={getFormationTypeLabel}
              />
            </SelectBoxWrapper>
            <SelectBoxWrapper>
              <SelectBox
                value={effectiveInfoType}
                selectType={SelectType.PE_INFO_TYPE}
                handleChange={(value) => handleInfoTypeChange(peId, value)}
                direction={false}
              />
            </SelectBoxWrapper>
          </SelectBoxContainer>
          <PEIndicator peId={peId}>: Formation</PEIndicator>
        </PEHeader>
      )}
      <FormationGridView
        peId={peId}
        formation={data}
        displaySize={effectiveDisplaySize}
        infoType={effectiveInfoType}
      />
    </FormationWrapper>
  );
};

const FormationWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default Formation;
